import { styled, isPropValid, Colors } from '@unfold/theme';
import { ICheckboxInputProps } from './types';

export const ToggleContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 21px;
`;

export const ToggleInput = styled('input', {
  shouldForwardProp: (prop) => isPropValid(prop)
})<ICheckboxInputProps>`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${Colors.BLACK};
  }

  &:checked + span:before {
    -webkit-transform: translateX(19px);
    -ms-transform: translateX(19px);
    transform: translateX(19px);
  }
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${Colors.G400};
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;


  &:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 3px;
    bottom: 3px;
    background-color: ${Colors.G700};
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
`;